// extracted by mini-css-extract-plugin
export var quillEditor = "_j8-1";
export var variable = "_j8-0";